/** @format */

import {
	AppProductReviewState,
	InvalidResponse,
	Review,
	selectProductIncludedInformation,
	selectProductReviews
} from '@product-reviews/data-access';
import { Store, select } from '@ngrx/store';
import { filter, map, shareReplay } from 'rxjs/operators';

import { Component, inject } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconStarFilled,
	homefieldIconStarHalf,
	homefieldIconStarOutlined
} from '@dsg-tech/homefield-angular-icons';
import { CommonModule } from '@angular/common';
import { ReviewCardComponent } from '../review-card/review-card.component';
import { ReviewSliderComponent } from '../review-slider/review-slider.component';

@Component({
	selector: 'product-reviews-review-latest-carousel',
	templateUrl: './review-latest-carousel.component.html',
	styleUrl: './review-latest-carousel.component.scss',
	imports: [CommonModule, HomefieldIconLibraryModule, ReviewCardComponent, ReviewSliderComponent]
})
export class ReviewLatestCarrouselComponent {
	private readonly store = inject(Store<AppProductReviewState>);
	readonly homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

	latestReview$ = this.store.pipe(
		select(selectProductReviews),
		filter((review) => review.length > 0),
		map((reviews: Review[]) => reviews.slice(0, 5)),
		shareReplay(1)
	);

	productInformation$ = this.store.pipe(
		select(selectProductIncludedInformation),
		filter((product) => !(product instanceof InvalidResponse)),
		shareReplay(1)
	);

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([
			homefieldIconStarFilled,
			homefieldIconStarHalf,
			homefieldIconStarOutlined
		]);
	}

	/*
	 * Track review changed
	 */
	protected trackByReview(index: number, review: Review): string {
		return review.Id;
	}
}
